
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.333 5.625h-2.324c-.501 0-.752 0-.988-.071-.236-.072-.445-.21-.861-.489-.626-.417-1.339-.892-1.693-1-.354-.107-.73-.107-1.482-.107-1.021 0-1.68 0-2.14.19-.459.191-.82.552-1.543 1.275l-.636.636c-.163.163-.244.244-.294.324a.833.833 0 00.051.957c.06.075.149.147.328.292a1.66 1.66 0 002.22-.124l1.028-1.035h.834l5 5.03a1.19 1.19 0 010 1.677 1.174 1.174 0 01-1.667 0l-.417-.42m0 0l-2.5-2.514m2.5 2.514a1.19 1.19 0 010 1.677 1.173 1.173 0 01-1.666 0l-.834-.838m0 0a1.19 1.19 0 010 1.676 1.173 1.173 0 01-1.666 0l-1.25-1.257m2.916-.42l-1.666-1.666m-1.25 2.086l-.417-.42m.417.42a1.19 1.19 0 010 1.676 1.174 1.174 0 01-1.667 0l-2.353-2.402c-.484-.493-.725-.74-1.035-.87-.31-.13-.655-.13-1.346-.13h-.266","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.333 12.292H16.25M7.083 5.625H1.666","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    